import React, { useRef, useState } from 'react'
import ImageUploading from 'react-images-uploading';
import SubirContainer from './Subir';
import { MDBBtn, MDBCard, MDBCol, MDBIcon, MDBPageItem, MDBPageNav, MDBPagination, MDBRow } from 'mdbreact';
import ContainerImagen from './Imagen';
import { CloseSquare, PaperUpload, Upload } from 'react-iconly';
import './index.css';
import ContainerCard from './Card';
import UsePagination from './Hook/UsePagination';

const SubirImagenes = ({ onUpload,
    onSelect,
    onRemove,
    dataSources = [] }) => {

    const [images, setImages] = useState([]);

    const { items, handleRegresar, handleSiguiente } = UsePagination(dataSources)


    const [selectedImages, setSelectedImages] = useState([]);
    const maxNumber = 10;

    const onChange = (imageList, addUpdateIndex) => {
        setImages(imageList);
    };

    const greaterZeroUpload = images.length > 0 ? false : true;
    const greaterZeroMedia = selectedImages.length > 0 ? false : true;

    const onSelectImage = (checked, index, url, img) => {
        const data = {
            data_url: url,
            index,
            ...img,
        };
        if (checked) {
            setSelectedImages([data])
        } else {
            setSelectedImages([])
        }
    };

    const onClear = () => {
        setSelectedImages([]);
    };

    const uploadImages = () => {
        setImages([])
        onUpload(images)
    }

    return (
        <MDBCard border='0'>
            <MDBRow className='mb-2 '>
                <MDBCol>
                    <ImageUploading
                        multiple
                        value={images}
                        onChange={onChange}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                    >
                        {({
                            onImageUpload,
                            onImageRemoveAll,
                            onImageRemove,
                            isDragging,
                            dragProps,
                            errors
                        }) => (
                            // write your building UI
                            <div className="upload__image-wrapper">
                                <SubirContainer
                                    dragProps={dragProps}
                                    isDragging={isDragging}
                                    onImageUpload={onImageUpload}
                                />
                                <div className="upload-image-preview">
                                    <MDBRow className='mb-2'>
                                        <MDBCol md='6'>
                                            <div className='d-flex  flex-wrap'>
                                                {images.map((image, index) => (
                                                    <ContainerImagen key={index} url={image.data_url} index={index} onImageRemove={onImageRemove} />
                                                ))}
                                            </div>

                                        </MDBCol>
                                        <MDBCol md='6' >
                                            <MDBBtn
                                                color='danger'
                                                style={{
                                                    marginRight: 5,
                                                }}
                                                rounded
                                                size='sm'
                                                disabled={greaterZeroUpload}
                                                onClick={() => setImages([])}
                                            >
                                                <CloseSquare set="broken" size={18} primaryColor="white" />
                                            </MDBBtn>
                                            <MDBBtn
                                                rounded
                                                size='sm'
                                                disabled={greaterZeroUpload}
                                                color="purple"
                                                onClick={uploadImages}
                                            >
                                                <Upload set="broken" size={18} primaryColor="white" />
                                            </MDBBtn>
                                        </MDBCol>

                                    </MDBRow>
                                    {errors && <div>
                                        {errors.maxNumber && <span>El número de imágenes seleccionadas supera numero maximo de {maxNumber}</span>}
                                        {errors.acceptType && <span>El tipo de archivo seleccionado no está permitido</span>}
                                        {errors.maxFileSize && <span>El tamaño de archivo seleccionado supera maxFileSize</span>}
                                        {errors.resolution && <span>El archivo seleccionado no coincide con la resolución deseada</span>}
                                    </div>}
                                </div>


                            </div>
                        )}
                    </ImageUploading>
                </MDBCol>
                <MDBCol md='5'>
                    <div className="media-library">
                        {items && items.map((img, index) => {
                            const includeImage = selectedImages.find((image) => {
                                return image.index === index ? true : false;
                            });
                            return (
                                <ContainerCard
                                    index={index}
                                    key={index}
                                    checked={includeImage}
                                    onRemove={() => onRemove(img.id, img.path)}
                                    onChange={(e) =>
                                        onSelectImage(e.target.checked, index, img.data_url, img)
                                    }
                                    imageURL={img.data_url}
                                />
                            );
                        })}
                    </div>
                    <MDBRow className='button-confirm'>
                        {selectedImages && selectedImages.length > 0 && <>
                            <MDBCol md='2' >
                                <div className='d-flex  flex-wrap'>
                                    {selectedImages.map((image, index) => (
                                        <ContainerImagen key={index} url={image.data_url} onImageRemove={onClear} />
                                    ))}
                                </div>
                            </MDBCol>
                            <MDBCol>
                                <MDBBtn
                                    rounded
                                    size='sm'
                                    disabled={greaterZeroMedia}
                                    color="purple"
                                    onClick={() => onSelect(selectedImages)}
                                >
                                    <PaperUpload set="broken" size={18} primaryColor="white" />
                                </MDBBtn>
                            </MDBCol>
                        </>}
                        <MDBCol>
                            <MDBPagination className="mb-0">
                                <MDBPageItem>
                                    <MDBPageNav aria-label="Previous" onClick={handleRegresar}>
                                        <span aria-hidden="true">&laquo;</span>
                                    </MDBPageNav>
                                </MDBPageItem>

                                <MDBPageItem>
                                    <MDBPageNav aria-label="Previous" onClick={handleSiguiente}>
                                        <span aria-hidden="true">&raquo;</span>
                                    </MDBPageNav>
                                </MDBPageItem>
                            </MDBPagination>
                        </MDBCol>
                    </MDBRow>
                </MDBCol>
            </MDBRow>

        </MDBCard >

    )
}

export default SubirImagenes